import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Badge } from 'primereact/badge';
import { InputSwitch } from 'primereact/inputswitch';

import { JobPortalTab } from './JobPortalTab';
import { deleteData, getAllDetails, postAllData } from '../../service/ProductService';
import { DEPARTMENT_LIST, UPDATE_JOB_STATUS, JOB_LIST, DELETE_JOB, DOWNLOAD_JOB_LIST, EXPORT_JOB_CSV_LIST } from '../../config/ApiConstant';
import { defaultPageRowOptions, defaultRowOptions, paginatorLinks, showingEntries, SkeletonbodyTemplate, Skeletonitems } from '../../appconfig/Settings';
import { JobListColumns } from '../../appconfig/DatatableSetting';
import moment from 'moment';
import { setJobAppStatus } from '../../appconfig/AppHelper';
import { createdAtTemplate } from '../../appconfig/DatatableTemplateSetting';
import { Dialog } from 'primereact/dialog';
import { formatDate } from '../../appconfig/AppHelper';
import CustomDatePicker from '../../components/CustomDatePicker/CustomDatePicker';

export const JobList = () => {
    document.title = 'Job List | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);

    // Date Object
    const storedDates = localStorage.getItem('joblist_app');
    let initialStartDate = moment().subtract(30, 'days').toDate();
    let initialEndDate = moment().toDate();

    if (storedDates) {
        try {
            const parsed = JSON.parse(storedDates);
            initialStartDate = parsed.startDate ? new Date(parsed.startDate) : initialStartDate;
            initialEndDate = parsed.endDate ? new Date(parsed.endDate) : initialEndDate;
        } catch (error) {
            console.error('Error parsing stored dates', error);
        }
    }

    const [dates, setDates] = useState({
        start: initialStartDate,
        end: initialEndDate
    });

    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [departments, setDepartments] = useState<any>([]);
    const [studentsList, setStudentsList] = useState<any>([]);
    const [selectedDepartment, setSelectedDepartment] = useState<any>({});
    const [approveId, setApproveId] = useState<any>(null);
    const [approveVal, setApproveVal] = useState<any>(null);
    const [approveModal, setApproveModal] = useState<boolean>(false);
    const [approveLoader, setApproveLoader] = useState<boolean>(false);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);

    // useEffect
    useEffect(() => {
        getDetartmentsList();
    }, []);

    useEffect(() => {
        getStudentsList();
    }, [dates, selectedDepartment]);

    // Get departments list
    const getDetartmentsList = async () => {
        try {
            const response = await getAllDetails(DEPARTMENT_LIST);
            if (response) {
                const departmentData: any = [];
                for (let i = 0; i < response.length; i++) {
                    const departmentObj: any = {};

                    departmentObj['name'] = response[i].dname;
                    departmentObj['code'] = response[i].id;
                    departmentData.push(departmentObj);
                }
                setDepartments(departmentData);
            } else {
                setDepartments([]);
            }
        } catch (error: any) {
            setDepartments([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get students list
    const getStudentsList = async () => {
        try {
            setPageLoad(false);
            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';
            const response = await getAllDetails(JOB_LIST + '?start_date=' + startDate + '&end_date=' + endDate + '&dept_id=' + selectedDepartment?.code + '&backoffice=backoffice');
            if (response) {
                setStudentsList(response);
                setPageLoad(true);
            }
        } catch (error: any) {
            setDepartments([]);
            setPageLoad(true);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    const leftToolbarTemplate = () => {
        return (
            <>
                <Dropdown value={selectedDepartment} name="dept" options={departments} filter optionLabel="name" placeholder="Select Department" onChange={(e) => setSelectedDepartment(e.value)} />
            </>
        );
    };

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });

        if (start && end) {
            localStorage.setItem(
                'joblist_app',
                JSON.stringify({
                    startDate: moment(start).format('YYYY-MM-DD'),
                    endDate: moment(end).format('YYYY-MM-DD')
                })
            );
        }
    };
    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <CustomDatePicker startDate={dates?.start} endDate={dates?.end} onChange={onDateChange} />

                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAllFilter()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAllFilter = () => {
        setGlobalFieldFilter(null);
    };
    // Open approve modal
    const openApproveModal = (status: any, id: any) => {
        setApproveId(id);
        setApproveVal(status);
        setApproveModal(true);
    };

    // Close approve modal
    const closeApproveModal = () => {
        setApproveId(null);
        setApproveVal(null);
        setApproveLoader(false);
        setApproveModal(false);
    };

    // On approve student
    const onApproveStudent = async () => {
        try {
            setApproveLoader(true);

            let formData: any = new FormData();
            let status = approveVal === true ? 'active' : 'deactive';
            formData.append('status', status);
            formData.append('id', approveId);
            const response = await postAllData(UPDATE_JOB_STATUS, formData);
            if (response) {
                setApproveLoader(false);
                setApproveId(null);
                setApproveVal(null);
                toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                setTimeout(() => {
                    setApproveModal(false);
                    getStudentsList();
                }, 800);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setApproveLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for approve
    const ApproveTemplate = (rowData: any) => {
        return (
            <>
                <InputSwitch checked={rowData?.status === 'active' ? true : false} onChange={(e) => openApproveModal(e.value, rowData.id)} defaultChecked={rowData.status === 'active' ? true : false} />
            </>
        );
    };

    // Open delete modal
    const openDeleteModal = (id: any) => {
        setDeleteId(id);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setDeleteModal(false);
    };

    // On delete student
    const onDeleteStudent = async () => {
        try {
            setDeleteLoader(true);
            // Delete api call
            const response = await deleteData(DELETE_JOB, deleteId);
            if (response) {
                setDeleteLoader(false);
                setDeleteModal(false);
                setDeleteId(null);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.message
                });
                setTimeout(() => {
                    getStudentsList();
                }, 1500);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setDeleteLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDeleteLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for action
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <Button icon="pi pi-trash" tooltip="Delete" tooltipOptions={{ position: 'top' }} className="p-button-danger" onClick={() => openDeleteModal(rowData.id)} />
            </>
        );
    };

    // Template for status
    const statusTemplate = (rowData: any) => {
        let applicationBadgeInfo = setJobAppStatus(rowData.status);
        return (
            <>
                <Badge value={applicationBadgeInfo.value} severity={applicationBadgeInfo.severity}></Badge>
            </>
        );
    };

    // Template for expiry date
    const expCreatedAtTemplate = (rowData: any) => {
        return <>{!window.cn(rowData.created_at) ? formatDate(moment(rowData.created_at).add(30, 'days')) : ''}</>;
    };

    // Template for job title
    const JobTitleTemplate = (rowData: any) => {
        return (
            <>
                <Button tooltip={rowData?.jtitle} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">{!window.cn(rowData.jtitle) ? rowData.jtitle : ''}</div>
                </Button>
            </>
        );
    };

    return (
        <>
            <JobPortalTab mainTabLabel="Job List" />
            <Toast ref={toast} />
            <div className="grid crud-demo mt-3">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={studentsList}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    showGridlines
                                    stripedRows
                                    rows={defaultRowOptions}
                                    paginator={studentsList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    emptyMessage="No Jobs Found"
                                    removableSort
                                >
                                    {JobListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'status') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={statusTemplate} />;
                                        } else if (col.field === 'created_at') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={createdAtTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'exp_created_at') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={expCreatedAtTemplate} style={{ minWidth: '8rem' }} />;
                                        } else if (col.field === 'approve') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={ApproveTemplate} />;
                                        } else if (col.field === 'jtitle') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={JobTitleTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {JobListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Approve Dialog */}
            <Dialog
                visible={approveModal}
                className="p-fluid"
                style={{ width: '100vh' }}
                header={'Approve Application'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeApproveModal} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => onApproveStudent()} loading={approveLoader} />
                    </>
                }
                onHide={closeApproveModal}
            >
                <h5>Note: It will Active or Inactive the Student.</h5>
            </Dialog>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete Job"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={onDeleteStudent} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this Job, This will be deleted permentatly.</span>
                </div>
            </Dialog>
        </>
    );
};
